/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import htmlParser from 'html-react-parser'
import _ from 'lodash';
import metadata from './MLStackTraceBoxComponent.metadata.json5';
import styles from './MLStackTraceBoxComponent.modules.scss';

// Component is only shown in read only
function MLStackTraceBoxComponent(props) {
    const {
        stackTrace
    } = props;

    const formatStackTraceContent = () => {
        return <React.Fragment>
            {htmlParser(stackTrace.replace(/(\r\n|\n|\r)/gm, '<br/>'))}
        </React.Fragment>
    };

    const overrides = {
        stackTraceBoxContainer: {
            visible: !!stackTrace && !_.isEmpty(stackTrace)
        },
        pIterable: {
            content: formatStackTraceContent()
        }
    };


    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLStackTraceBoxComponent.propTypes = {
    stackTrace: PropTypes.string.isRequired
};

export default MLStackTraceBoxComponent;